var map = {
	"./efj.gif": 8584,
	"./efp.gif": 7802,
	"./etj.gif": 6087,
	"./etp.gif": 498,
	"./ifj.gif": 3465,
	"./ifp.gif": 9791,
	"./itj.gif": 5560,
	"./itp.gif": 6824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 827;